export const SHIPPING_PARAM = 'pub_shippingEnabled';
export const PICKUP_PARAM = 'pub_pickupEnabled';

export const SHIPPING_FIELD = 'shippingEnabled';
export const PICKUP_FIELD = 'pickupEnabled';

export const isParamActive = value => value === true || value === 'true';

export const formatBooleanParam = selectedOptions =>
  selectedOptions && selectedOptions.length > 0 ? 'true' : null;

export const toUrlParams = formValues => {
  const pickupChecked = formValues?.[PICKUP_FIELD]?.includes?.('true');
  const payload = {
    [SHIPPING_PARAM]: formatBooleanParam(formValues?.[SHIPPING_FIELD]),
    [PICKUP_PARAM]: formatBooleanParam(formValues?.[PICKUP_FIELD]),
  };

  if (!pickupChecked) {
    payload.bounds = null;
    payload.pickupAddress = null;
    payload.pickupOrigin = null;
    payload.pickupRadius = null;
  }

  return payload;
};

export const clearUrlParams = () => ({
  [SHIPPING_PARAM]: null,
  [PICKUP_PARAM]: null,
  bounds: null,
  pickupAddress: null,
  pickupOrigin: null,
  pickupRadius: null,
});
